import { supabase } from '../supabaseClient';

export async function analyzeDocument(documentId, question) {
  const { data, error } = await supabase.functions.invoke('analyze-document', {
    body: { documentId, question },
  });

  if (error) throw error;
  if (data?.error) throw new Error(data.error);

  return data.reply;
}